import React from 'react';
import LandingPage from './LandingPage/LandingPage';
import Services from './Services/Services';
import Highlight from './HighlightSection/Highlight';
import Arcade from './Arcade/Arcade';
import ScreenShotScreen from './ScreenShotScreen/ScreenShotScreen';
import TabScreen from './TabScreen/TabScreen';
import LearnAndGrowSection from './ColorScreens/LearnAndGrowSection';
import SecuritySection from './ColorScreens/SecuritySection';
import PricingModelAd from './ColorScreens/PricingModelAd';
import { SCREEN_SHOT_CONTENT } from './ScreenShotScreen/export';
import { Helmet } from 'react-helmet-async';
import SubscribeSection from './NewsLetter/SubscribeSection';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Shipmnts: Freight Forwarding Software &amp; ERP for India</title>
        <meta name="description" content="Shipmnts is freight ERP software trusted by 6,000+ users across 180 freight forwarding companies. Manage operations, customs, finance, and compliance in one platform." />
        <link rel="alternate" hreflang="en-IN" href="https://shipmnts.com/in" />
        <link rel="alternate" hreflang="en-AE" href="https://shipmnts.com/uae" />
        <link rel="alternate" hreflang="en-US" href="https://shipmnts.com/us" />
        <link rel="alternate" hreflang="x-default" href="https://shipmnts.com" />
      </Helmet>
      <LandingPage />
      <Services />
      <Highlight />
      <Arcade />
      <ScreenShotScreen {...SCREEN_SHOT_CONTENT['customer_centric_features']} />
      <TabScreen />
      <ScreenShotScreen {...SCREEN_SHOT_CONTENT['actionable_insight']} />
      <ScreenShotScreen {...SCREEN_SHOT_CONTENT['productivity_and_multi_party_collaboration']} />
      <LearnAndGrowSection />
      <SecuritySection />
      <PricingModelAd />
      <SubscribeSection />
    </>
  );
};

export default Home;
